import __axios from "axios";
import { axiosV2 } from "config/@axios";
import storage from "@storage";
import * as uiActions from "store/actions/uiActions";
import i18next from "i18next";

export const FETCH_DOCUMENTS_PENDING = "Documents->uiActions::pendingDocuments";
export const FETCH_DOCUMENTS_SUCCESS =
  "Documents->uiActions::fetchDocumentsSuccess";
export const FETCH_DOCUMENTS_FAILED =
  "Documents->uiActions::fetchDocumentsFailed";
export const RESET_DOCUMENTS = "Documents->uiActions::resetDocuments";

export const ADD_DOCUMENT = "Documents->uiActions::addDocument";

export const UPDATE_DOCUMENT = "Documents->uiActions::updateDocument";
export const UPDATE_DOCUMENT_PENDING =
  "Documents->uiActions::updateDocumentPending";
export const UPDATE_DOCUMENT_SUCCESS =
  "Documents->uiActions::updateDocumentSuccess";
export const UPDATE_DOCUMENT_FAILED =
  "Documents->uiActions::updateDocumentFailed";
export const SET_DOCUMENT_UPDATE_MODAL =
  "Documents->uiActions::setDocumentUpdateModal";
export const CLOSE_DOCUMENT_UPDATE_MODAL =
  "Documents->uiActions::closeDocumentUpdateModal";

export const SET_ERROR_MESSAGE = "Documents->uiActions::setErrorMessage";
export const UPDATE_PROGRESS = "Documents->uiActions::updateProgress";
export const REMOVE_DOCUMENT = "Documents->uiActions::removeDocument";
export const DELETE_DOCUMENT = "Documents->uiActions::deleteDocument";
export const DELETE_DOCUMENT_SUCCESS =
  "Documents->uiActions::deleteDocumentSuccess";
export const DELETE_DOCUMENT_FAILED =
  "Documents->uiActions::deleteDocumentFailed";
export const SET_DELETE_DOCUMENT_MODAL =
  "Documents->uiActions::setDeleteDocumentModal";
export const CLOSE_DOCUMENT_DELETE_MODAL =
  "Documents->uiActions::closeDocumentDeleteModal";

export const SELECT_ALL = "Documents->uiActions::SelectAll";
export const SELECT_SINGLE = "Documents->uiActions::SelectSingle";

export const SHARE_TO_COMPOSE = "Documents->uiActions::shareToCompose";
export const CLEAR_SHARE_TO_COMPOSE =
  "Documents->uiActions::clearShareToCompose";
export const CHANGE_VIEW = "Documents->uiActions::changeView";

export const fetchDocuments =
  ({ signal, ...params } = {}) =>
  dispatch => {
    dispatch({
      type: FETCH_DOCUMENTS_PENDING,
      payload: { folder_id: params.folder_id, isStart: params?.start === 0 }
    });

    return axiosV2
      .get("documents", {
        params,
        signal
      })
      .then(response => {
        const xMore = parseInt(response?.headers?.["x-more"]);
        dispatch({
          type: FETCH_DOCUMENTS_SUCCESS,
          payload: {
            folder_id: params.folder_id,
            documents: response.data,
            hasMore: !!xMore,
            isStart: params?.start === 0
          }
        });
      })
      .catch(err => {
        if (
          __axios.isCancel(err) ||
          err?.code === "ERR_CANCELED" ||
          err?.name === "CanceledError"
        ) {
          dispatch({ type: FETCH_DOCUMENTS_FAILED, payload: null });
          return;
        }
        dispatch({
          type: FETCH_DOCUMENTS_FAILED,
          payload: err?.errorMessage
        });
      });
  };

export const resetDocuments = () => ({
  type: RESET_DOCUMENTS
});

export const addDocument = payload => {
  const data = { ...payload, timestamp: new Date().getTime() };
  return {
    type: ADD_DOCUMENT,
    payload: data
  };
};

export const updateDocument =
  (payload, action = "rename") =>
  dispatch => {
    dispatch({
      type: UPDATE_DOCUMENT_PENDING
    });
    return axiosV2
      .put(`/documents/${payload.id}`, payload)
      .then(res => {
        dispatch({
          type: UPDATE_DOCUMENT,
          payload: res.data
        });
        dispatch({
          type: UPDATE_DOCUMENT_SUCCESS,
          payload
        });
        dispatch(
          uiActions.addSnackbar({
            message: i18next.t(`documents:fields.${action}_success_message`)
          })
        );
        if (action === "move") {
          dispatch(removeDocument([payload.id]));
        } else if (action === "rename") {
          setDocumentUpdateModal({
            updateDocumentIds: null,
            updateDocumentName: null
          });
        }
      })
      .catch(err => {
        dispatch({
          type: UPDATE_DOCUMENT_FAILED,
          payload: {
            updateDocumentError: err.errorMessage
          }
        });
      });
  };

export const setDocumentUpdateModal = payload => {
  return {
    type: SET_DOCUMENT_UPDATE_MODAL,
    payload
  };
};

export const closeDocumentUpdateModal = payload => {
  return {
    type: CLOSE_DOCUMENT_UPDATE_MODAL,
    payload
  };
};

export const updateProgress = (fileId, newProgress) => {
  return {
    type: UPDATE_PROGRESS,
    payload: {
      fileId,
      newProgress
    }
  };
};

export const removeDocument = id => {
  return {
    type: REMOVE_DOCUMENT,
    payload: id
  };
};

export const moveToTrashDocument = documentId => dispatch => {
  return axiosV2
    .put(`/documents/${documentId}`, {
      action: "update",
      id: documentId,
      folder_id: 3
    })
    .then(res => {
      dispatch({
        type: DELETE_DOCUMENT_SUCCESS,
        payload: documentId
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t(`documents:fields.move_to_trash_success_message`)
        })
      );
      dispatch(removeDocument([documentId]));
      setDeleteDocumentModal({
        deleteDocumentIds: null,
        deleteDocumentName: null
      });
    })
    .catch(err => {
      dispatch({
        type: DELETE_DOCUMENT_FAILED,
        payload: {
          updateDocumentError: err.errorMessage
        }
      });
    });
};

export const deleteDocument = documentId => dispatch => {
  return axiosV2
    .delete(`/documents/${documentId}`)
    .then(() => {
      dispatch({
        type: DELETE_DOCUMENT_SUCCESS,
        payload: documentId
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("documents:fields.delete_success_message")
        })
      );
      setDeleteDocumentModal({
        deleteDocumentIds: null,
        deleteDocumentName: null
      });
    })
    .catch(err => {
      dispatch({
        type: DELETE_DOCUMENT_FAILED,
        payload: {
          errorMessage: err.errorMessage
        }
      });
    });
};

export const getDocument = documentId => dispatch => {
  return axiosV2
    .get(`/documents/${documentId}`)
    .then(res => {
      dispatch({
        type: UPDATE_DOCUMENT,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: UPDATE_DOCUMENT_FAILED,
        payload: {
          updateDocumentError: err.errorMessage
        }
      });
    });
};

export const setDeleteDocumentModal = payload => {
  return {
    type: SET_DELETE_DOCUMENT_MODAL,
    payload
  };
};

export const closeDocumentDeleteModal = payload => {
  return {
    type: CLOSE_DOCUMENT_DELETE_MODAL,
    payload
  };
};

export const selectAll = isSelected => (dispatch, getState) => {
  const { documents } = getState();
  let list = documents.entities.allIds;

  dispatch({
    type: SELECT_ALL,
    payload: {
      isSelected,
      list
    }
  });
};

export const selectSingle = (id, isSelected) => ({
  type: SELECT_SINGLE,
  payload: {
    id,
    isSelected
  }
});

export const shareToCompose = payload => ({
  type: SHARE_TO_COMPOSE,
  payload
});

export const clearShareToCompose = payload => ({
  type: CLEAR_SHARE_TO_COMPOSE,
  payload
});

export const setErrorMessage = payload => ({
  type: SET_ERROR_MESSAGE,
  payload
});

export const changeView = payload => dispatch => {
  storage.set("documents_view", payload);

  dispatch({
    type: CHANGE_VIEW,
    payload
  });
};
